import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { isPhone } from '@helpers';
import type { WithColor } from '@styles/colors';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { SETTINGS_LIMITED_ROUTE } from '@config/tenantRestrictions';

import Account from '@components/settings/v2/structure/account/account';
import AccountDetails from '@components/settings/v2/structure/account/accountDetails';
import Users from '@components/settings/v2/structure/users/users';
import UsersMobile from '@components/settings/v2/structure/users/users/usersMobile';
import UserDetails from '@components/settings/v2/structure/users/userDetails';
import Connector from '@components/settings/v2/structure/connector/connector';
import FileConnector from '@components/settings/v2/structure/connector/fileConnector';
import FileConnectorDetails from '@components/settings/v2/structure/connector/fileConnectorDetails';
import Company from '@components/settings/v2/structure/company/company';
import Support from '@components/settings/v2/structure/support/support';

const Stack = createStackNavigator();
const AccountDetailsScreen = AccountDetails({});

interface SettingsLimitedNavigationProps extends WithColor {
  selectedTab: string;
  toggleChangeLanguage: () => void;
  toggleChangeTheme: () => void;
  role: string;
  rootStack: typeof SETTINGS_LIMITED_ROUTE;
}

const SettingsLimitedNavigation = (parentProps: SettingsLimitedNavigationProps) => {
  const { C } = parentProps;
  const screenOptions = {
    ...NAVIGATION_CONFIG,
    animationEnabled: false,
    cardStyle: { backgroundColor: C('Background/Light/Detail') },
  } as const;

  const renderScreen = (Screen: React.ComponentType<any>) => (p: any) => <Screen {...parentProps} {...p} />;

  return (
    <Stack.Navigator initialRouteName="Account" screenOptions={screenOptions}>
      <Stack.Screen name="Account">{renderScreen(Account)}</Stack.Screen>
      <Stack.Screen name="AccountDetails">{renderScreen(AccountDetailsScreen)}</Stack.Screen>
      <Stack.Screen name="Users">{renderScreen(isPhone ? UsersMobile : Users)}</Stack.Screen>
      <Stack.Screen name="UserDetails">{renderScreen(UserDetails)}</Stack.Screen>
      <Stack.Screen name="Connector">{renderScreen(Connector)}</Stack.Screen>
      <Stack.Screen name="FileConnector">{renderScreen(FileConnector)}</Stack.Screen>
      <Stack.Screen name="FileConnectorDetails">{renderScreen(FileConnectorDetails)}</Stack.Screen>
      <Stack.Screen name="Company">{renderScreen(Company)}</Stack.Screen>
      <Stack.Screen name="Support">{renderScreen(Support)}</Stack.Screen>
    </Stack.Navigator>
  );
};

export default SettingsLimitedNavigation;
